import React from 'react';
import TimePicker from '../shared/TimePicker';
import OptionButton from '../shared/OptionButton';
import { getDurationLimits } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const SKIP_TEXT = "I don't know";

const LongestRunTimeStep: React.FC<StepProps> = ({ answer, onAnswer, answers }) => {
  const limits = getDurationLimits(answers.programme_type ?? null);
  const isSkipped = answer === SKIP_TEXT;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32, alignItems: 'center' }}>
      <TimePicker
        value={typeof answer === 'number' ? answer : null}
        onChange={onAnswer}
        min={limits.min}
        max={limits.max}
        initialValue={limits.initial}
      />
      <OptionButton
        label={SKIP_TEXT}
        value={SKIP_TEXT}
        selected={isSkipped}
        onClick={onAnswer}
      />
    </div>
  );
};

export default LongestRunTimeStep;
